import React from 'react';
import { Link, useParams } from 'react-router-dom';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@eluve/components';

export const ExperimentsBreadcrumbs: React.FC = () => {
  const { experimentId } = useParams() as {
    experimentId?: string;
  };

  const isNewExperiment = experimentId === 'new';

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/admin/experiments">Experiments</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {experimentId && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={`/admin/experiments/${experimentId}`}>
                  {isNewExperiment ? 'New Experiment' : 'Experiment Details'}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
